import { useMemo } from 'react';
import { useProductsQuery } from '@/data/products.queries';

export function useRelatedProducts(currentSlug?: string) {
  const { data, isLoading, error } = useProductsQuery({ limit: 12 });
  const products = error ? [] : data?.products ?? [];

  const relatedProducts = useMemo(() => {
    const filtered = currentSlug ? products.filter((product) => product.slug !== currentSlug) : products;
    return filtered.slice(0, 4);
  }, [products, currentSlug]);

  return {
    relatedProducts,
    isLoading,
    error,
  };
}
